import { dataHooks } from '../../../libs/dataHooks';

export const pictureDataHooks = dataHooks<{
  image: {};
  source: {};
}>('picture');
